<template>
  <v-app class="app-background ma-3 contact-us">
    <el-row type="flex" justify="center" class="my-4">
      <h1>Contact Us</h1>
    </el-row>
    <el-row type="flex" align="middle" class="ma-3">
      <el-col :span="4">
        <i class="el-icon-message" style="fontSize: 30px;"></i>
      </el-col>
      <el-col :span="20">
        <h3>email@gmail.com</h3>
        <p class="ma-0">Work Email</p>
        <el-divider style="margin: 0 !important"></el-divider>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" class="ma-3">
      <el-col :span="4">
        <i class="el-icon-phone" style="fontSize: 30px;"></i>
      </el-col>
      <el-col :span="20">
        <h3>088834828348</h3>
        <p class="ma-0">Main Phone</p>
        <el-divider style="margin: 0 !important"></el-divider>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" class="ma-3">
      <el-col :span="4">
        <i class="el-icon-location" style="fontSize: 30px;"></i>
      </el-col>
      <el-col :span="20">
        <h3>Jakarta Selatan</h3>
        <p class="ma-0">Address</p>
        <el-divider style="margin: 0 !important"></el-divider>
      </el-col>
    </el-row>

    <div class="bg-ellips"></div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ['1']
    };
  },
  methods: {},
  computed: {}
};
</script>

<style>
.app-background {
  background: white !important;
}
.el-collapse-item__header.is-active {
  color: #1989fa;
}
.contact-us .el-divider--horizontal {
  margin: 4px 0;
}
</style>
